import request from '@/utils/request'
// 登录接口
export function Login(data) {
    return request({
        url: '/user/login/pwd',
        method: 'post',
        data: data
    })
}
// 退出登录
export function outLogin(data) {
    return request({
        url: '/user/logout',
        method: 'post',
        data: data
    })
}
